import {ManipulationEditor} from "./ManipulationEditor.js";
import {BoxedObjectEditor} from "./BoxedObjectEditor.js";

const HANDLER_WIDTH = 6;

export class Handler extends ManipulationEditor {

	/**
	 * @param {ManipulationEditor} parent parent editor
	 */
	constructor(parent) {
		super(parent);
		this.hitBox = null;
	}

	get x() {
		return 0;
	}

	get y() {
		return 0;
	}

	set x(val) {
	}

	set y(val) {
	}

	get fg() {
		return S.HI_COLORS[6];
	}

	get bg() {
		return S.HI_COLORS[14];
	}

	hit(x, y) {
		if (this.hitBox) {
			if (x >= this.hitBox.left && x < (this.hitBox.left + this.hitBox.width)
				&& y >= this.hitBox.top && y < (this.hitBox.top + this.hitBox.height)) return this;
		}
		return null;
	}

	getCursor() {
		return "default";
	}

	/**
	 * @param {CanvasRenderingContext2D} ctx
	 * @param pixelWidth
	 */
	draw(ctx, pixelWidth = 1) {
		ctx.save();
		ctx.strokeStyle = this.fg;
		ctx.fillStyle = this.bg;
		ctx.setLineDash([]);
		ctx.lineWidth = pixelWidth;

		const hwidth = (window.devicePixelRatio * pixelWidth)*HANDLER_WIDTH;
		const rect = BoxedObjectEditor.strokeBox(this.x, this.y, hwidth, hwidth, pixelWidth);
		ctx.fillRect(rect.left, rect.top, rect.width, rect.height);
		ctx.strokeRect(rect.left, rect.top, rect.width, rect.height);
		ctx.restore();

		this.hitBox = BoxedObjectEditor.boundingBox(this.x, this.y, hwidth, hwidth, pixelWidth);
	}

	startDragging() {
		this.startX = this.x;
		this.startY = this.y;
	}

	drag(diffX, diffY, snapsX, snapsY) {
		const snap = super.drag(diffX, diffY, snapsX, snapsY);
		const newX = this.startX + diffX;
		const newY = this.startY + diffY;
		BoxedObjectEditor.snap(newX, snapsX, (newValue)=>{
			snap.x = newValue;
			this.x = newValue;
		});
		BoxedObjectEditor.snap(newY, snapsY, (newValue)=>{
			snap.y = newValue;
			this.y = newValue;
		});
		if (snap.x === null) this.x = newX;
		if (snap.y === null) this.y = newY;
		return snap;
	}

	stopDragging(diffX, diffY, snapsX, snapsY) {
		this.drag(diffX, diffY, snapsX, snapsY);
	}
}